var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassCup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "glass_cup"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10129_20223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.332031,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10129_20223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "glass_cup_2",
    d: "M4.40078 13.4167C4.09939 13.4167 3.83932 13.3194 3.62057 13.125C3.40182 12.9306 3.27786 12.6826 3.2487 12.3813L2.08203 5.25H12.582L11.4154 12.3813C11.3862 12.6826 11.2622 12.9306 11.0435 13.125C10.8247 13.3194 10.5647 13.4167 10.2633 13.4167H4.40078ZM4.28411 13.4167L4.41536 12.25H10.2487L10.3799 13.4167H4.28411ZM4.16745 12.25H10.5112L11.2695 6.41667H3.39453L4.16745 12.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "salinity",
    d: "M7.33073 0.583366C5.99878 0.583366 4.88802 1.04031 3.99844 1.9542C3.10885 2.86809 2.66406 4.00559 2.66406 5.3667H3.83073C3.83073 4.32642 4.16128 3.46357 4.8224 2.77816C5.48351 2.09274 6.31962 1.75003 7.33073 1.75003C8.34184 1.75003 9.17795 2.09274 9.83906 2.77816C10.5002 3.46357 10.8307 4.32642 10.8307 5.3667H11.9974C11.9974 4.00559 11.5526 2.86809 10.663 1.9542C9.77344 1.04031 8.66267 0.583366 7.33073 0.583366Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassCup);
export default __webpack_public_path__ + "static/media/glass_cup.c5998d43a7a12a10c4d1a1e695466b16.svg";
export { ForwardRef as ReactComponent };